<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.update_ads") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            :identifier="
              [
                'mp4',
                'mov',
                'avi',
                'wmv',
                'flv',
                'mkv',
                'webm',
                'm4v',
              ].includes(data.image.path?.split('.').pop().toLowerCase())
                ? 'video'
                : 'image'
            "
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.advertisement')"
            @selectImage="selectImage"
            required
            :acceptVideo="true"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input Arabic -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            :maxlength="100"
            required
          />
          <!-- End:: Name Input Arabic -->

          <!-- Start:: Name Input English -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            :maxlength="100"
            required
          />
          <!-- End:: Name Input English -->

          <!-- {{ data.link_type }} -->
          <!-- Start:: Link Type Selection -->
          <base-select-input
            col="12"
            :placeholder="$t('PLACEHOLDERS.link_type')"
            :optionsList="linkTypeOptions"
            v-model="data.link_type"
          />
          <!-- End:: Link Type Selection -->

          <!-- Start:: External URL Input -->
          <base-input
            v-if="data.link_type?.id === 'external'"
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.external_url')"
            v-model.trim="data.external_url"
          />
          <!-- End:: External URL Input -->

          <!-- Start:: Internal Link Fields -->
          <template v-if="data.link_type?.id === 'internal'">
            <!-- Start:: Interface Type Selection -->
            <base-select-input
              col="6"
              :placeholder="$t('PLACEHOLDERS.interface_type')"
              :optionsList="interfaceTypeOptions"
              v-model="data.interface_type"
              @input="onInterfaceTypeChange"
            />
            <!-- End:: Interface Type Selection -->

            <!-- Start:: Item Selection -->
            <base-select-input
              col="6"
              :placeholder="$t('PLACEHOLDERS.item')"
              :optionsList="itemOptions"
              v-model="data.item_id"
              :disabled="!data.interface_type"
            />
            <!-- End:: Item Selection -->
          </template>
          <!-- End:: Internal Link Fields -->

          <!-- Start:: Start Date -->
          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledStartDate"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
            required
          />
          <!-- End:: Start Date -->

          <!-- Start:: End Date -->
          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledEndDate"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
            required
          />
          <!-- End:: End Date -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "EditAds",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
        link_type: null,
        external_url: null,
        interface_type: null,
        item_id: null,
      },
      // End:: Data Collection To Send

      // Start:: Dropdown Options
      linkTypeOptions: [
        {
          id: "internal",
          name: this.$t("PLACEHOLDERS.internal_link") || "رابط داخلي",
        },
        {
          id: "external",
          name: this.$t("PLACEHOLDERS.external_link") || "رابط خارجي",
        },
      ],
      interfaceTypeOptions: [
        {
          id: "product",
          name: this.$t("PLACEHOLDERS.product") || "منتج",
        },
        {
          id: "package",
          name: this.$t("TITLES.package") || "باقة",
        },
      ],
      products: [],
      packages: [],
      // End:: Dropdown Options
    };
  },

  computed: {
    itemOptions() {
      if (this.data.interface_type?.id === "product") {
        return this.products;
      } else if (this.data.interface_type?.id === "package") {
        return this.packages;
      }
      return [];
    },
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    disabledStartDate(current) {
      return current && current < moment().startOf("day");
    },

    disabledEndDate(current) {
      if (!this.data.publish_start_date) {
        return current && current < moment().startOf("day");
      }
      return (
        current && current < moment(this.data.publish_start_date).startOf("day")
      );
    },

    onInterfaceTypeChange() {
      this.data.item_id = null;
      if (
        this.data.interface_type?.id === "product" &&
        this.products.length === 0
      ) {
        this.fetchProducts();
      } else if (
        this.data.interface_type?.id === "package" &&
        this.packages.length === 0
      ) {
        this.fetchPackages();
      }
    },

    // Start:: Fetch Products
    async fetchProducts() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "products",
          params: { is_active: 1, limit: 0, page: 0 },
        });
        this.products = res.data.data.data.map((product) => ({
          id: product.id,
          name: product.name,
        }));
      } catch (error) {
        console.log(error);
      }
    },
    // End:: Fetch Products

    // Start:: Fetch Packages
    async fetchPackages() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "packages",
          params: { is_active: 1, limit: 0, page: 0 },
        });
        this.packages = res.data.data.data.map((pkg) => ({
          id: pkg.id,
          name: pkg.name,
        }));
      } catch (error) {
        console.log(error);
      }
    },
    // End:: Fetch Packages

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      // Validate name Arabic
      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (this.data.nameAr.length < 2) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.min_length_2") || "الحد الأدنى حرفين"
        );
        return;
      }

      // Validate name English
      if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (this.data.nameEn.length < 2) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.min_length_2") || "الحد الأدنى حرفين"
        );
        return;
      }

      // Validate image size if new file is uploaded (10MB = 10485760 bytes)
      if (this.data.image.file && this.data.image.file.size > 10485760) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.max_file_size_10mb") ||
            "الحد الأقصى لحجم الملف 10 ميجا"
        );
        return;
      }

      // Validate start date
      if (!this.data.publish_start_date) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.start_date") || "تاريخ البداية مطلوب"
        );
        return;
      }

      // Validate end date
      if (!this.data.publish_end_date) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.end_date") || "تاريخ النهاية مطلوب"
        );
        return;
      }

      // Validate link type fields
      if (this.data.link_type?.id === "external" && !this.data.external_url) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.external_url") || "الرابط الخارجي مطلوب"
        );
        return;
      }

      if (this.data.link_type?.id === "internal") {
        if (!this.data.interface_type) {
          this.isWaitingRequest = false;
          this.$message.error(
            this.$t("VALIDATION.interface_type") || "نوع الواجهة مطلوب"
          );
          return;
        }
        if (!this.data.item_id) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.item") || "العنصر مطلوب");
          return;
        }
      }

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Append Required Data
      REQUEST_DATA.append("title[ar]", this.data.nameAr);
      REQUEST_DATA.append("title[en]", this.data.nameEn);

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      REQUEST_DATA.append("start_date", this.data.publish_start_date);
      REQUEST_DATA.append("end_date", this.data.publish_end_date);
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      // Append Optional Link Data
      if (this.data.link_type) {
        REQUEST_DATA.append(
          "link_type",
          this.data.link_type.id || this.data.link_type
        );

        if (
          (this.data.link_type.id || this.data.link_type) === "external" &&
          this.data.external_url
        ) {
          REQUEST_DATA.append("external_url", this.data.external_url);
        }

        if ((this.data.link_type.id || this.data.link_type) === "internal") {
          if (this.data.interface_type) {
            REQUEST_DATA.append(
              "interface_type",
              this.data.interface_type.id || this.data.interface_type
            );
          }
          if (this.data.item_id) {
            REQUEST_DATA.append(
              "item_id",
              this.data.item_id.id || this.data.item_id
            );
          }
        }
      }

      REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `banners/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/ads/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // start all ads data
    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `banners/${this.$route.params.id}`,
        });
        const responseData = res.data.data.banner;
        this.data.image.path = responseData?.image;
        this.data.nameAr = responseData?.title_ar;
        this.data.nameEn = responseData?.title_en;
        this.data.publish_start_date = responseData?.start_date;
        this.data.publish_end_date = responseData?.end_date;
        this.data.active = responseData?.is_active;

        // Convert link_type string to object for select input
        if (responseData?.link_type) {
          const linkTypeOption = this.linkTypeOptions.find(
            (opt) => opt.id === responseData.link_type
          );
          this.data.link_type = linkTypeOption || null;
        }

        this.data.external_url = responseData?.external_url;

        // Convert interface_type string to object for select input
        if (responseData?.interface_type) {
          const interfaceTypeOption = this.interfaceTypeOptions.find(
            (opt) => opt.id === responseData.interface_type
          );
          this.data.interface_type = interfaceTypeOption || null;
        }

        // Fetch items if interface type is set
        if (
          responseData?.link_type === "internal" &&
          responseData?.interface_type
        ) {
          if (responseData.interface_type === "product") {
            await this.fetchProducts();
          } else if (responseData.interface_type === "package") {
            await this.fetchPackages();
          }

          // Set item_id after fetching the list
          if (responseData?.model_id && responseData?.model) {
            this.data.item_id = {
              id: responseData.model_id,
              name: responseData.model.name || responseData.model.name_ar,
            };
          }
        }
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end all ads data
  },

  created() {
    // Start:: Fire Methods
    this.getAdsData();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
</style>
